export const DEFAULT_ROLES_LIST_PAGE_SIZE: number = 10;

export const ADMIN_ROLE_SLUG = 'Full privilege';
export const SITE_ADMINISTRATOR_GROUP_NAME = 'Site Administrators';